import { trackEvent } from '../../../Assets/helpers/tracking/track.js';

// ADD DEBUG MODE (Tap `debug()` in console)
globalThis.debug = () => (document.body.dataset.debug = true);

// Track "add to cart" event on product forms
if (!globalThis.__productCardAddToCartTracking) {
  // ProductCard entry points (ProductCard, ProductCards, ProductCardsKeyed) are separate bundles,
  // so register this global listener only once.
  globalThis.__productCardAddToCartTracking = true;

  globalThis.addEventListener('addcartitem', (event) => {
    if (document.body.dataset.debug !== undefined) {
      event.preventDefault();
    }

    const data = event.target.dataset?.track;
    const componentID = event.target.dataset?.componentId;
    const productID = event.target.dataset?.productId;

    if (!data || !componentID || !productID) return;

    trackEvent('addcartitem', componentID, JSON.parse(data), productID);
  });
}

// NOTE: trackEvent('beforeaddcartitem', componentID, JSON.parse(data), productID);

/* TRACKING SORTING */
for (const input of document.querySelectorAll('.js-tracking-sortTypes')) {
  input.addEventListener('change', (event) => {
    const sortingCodes = {
      Relevance: '0',
      LowestPrice: '5',
      HighestPrice: '500',
      SaleScore: '600',
      UserRating: '700'
    };

    const data = { sortingMethod: sortingCodes[event.target.value] };

    trackEvent('sortingmethodchange', 'SearchResults', data);
  });
}

/* TRACKING DISPLAYMODE */
for (const button of document.querySelectorAll('.js-tracking-displayMode')) {
  button.addEventListener('click', (event) => {
    const displayModeCodes = {
      mosaic: 'Mosaic',
      list: 'List'
    };

    const data = { layout: displayModeCodes[event.currentTarget.dataset.display] };

    trackEvent('layoutchange', 'SearchResults', data);
  });
}

/* TRACKING CATEGORIES */
for (const input of document.querySelectorAll('.js-tracking-category')) {
  input.addEventListener('change', (event) => {
    const data = {
      category: [
        {
          label: event.target.title,
          id: typeof event.target.value === 'string' ? event.target.value.replace(/,/, '__') : ''
        }
      ]
    };

    trackEvent('categorychange', 'SearchResults', data);
  });
}

/* TRACKING FILTERS (facets) */
for (const facet of document.querySelectorAll('.js-tracking-filter')) {
  facet.addEventListener('change', () => {
    const filterBlocks = document.querySelectorAll('.js-filters-blocks');

    const activeBlocks = [...filterBlocks].filter(
      (block) => block.querySelectorAll('.js-tracking-filter:checked').length > 0
    );

    const data = activeBlocks.map((block) => {
      const inputsChecked = block.querySelectorAll('.js-tracking-filter:checked');

      return {
        refinerID: block.dataset.trackingId,
        refinerName: block.dataset.trackingTitle,
        refinerValue: [...inputsChecked].map((input) => input.value),
        refinerValueLabel: [...inputsChecked].map((input) => input.parentNode.textContent.trim())
      };
    });

    trackEvent('refinerchange', 'SearchResults', { refiner: [...data] });
  });
}
